'use strict';

var Misc = require('utils/misc');

var ApiDocumentationView = Marionette.ItemView.extend({
    template: require('components/profile/templates/api_documentation'),

    initialize: function (options) {
        this.api_key = options.api_key || '';
    },

    initializeDocumentation: function () {
        var self = this;

        this.ui = SwaggerUIBundle({
            url: '/api/v1/company/api-specification',
            dom_id: '#swagger-ui',

            presets: [SwaggerUIBundle.presets.apis, SwaggerUIStandalonePreset],
            plugins: [],

            layout: 'StandaloneLayout',

            deepLinking: false,

            onComplete: function () {
                if (self.api_key) {
                    self.ui.preauthorizeApiKey('ApiKeyAuth', self.api_key);
                }

                // replace download link text
                $('span.url').text('Download specification');
            },
        });
    },

    onAttach: function () {
        // load required Swagger UI files
        Misc.loadAdditionalFile('swagger/swagger-ui.css', 'css');
        Misc.loadAdditionalFile('swagger/swagger-ui-bundle.js', 'js');
        Misc.loadAdditionalFile('swagger/swagger-ui-standalone-preset.js', 'js');

        var self = this;
        // initialize documentation view
        setTimeout(function () {
            self.initializeDocumentation();
        }, 2000);
    },
});

module.exports = ApiDocumentationView;
